'use strict';

document.addEventListener('DOMContentLoaded', () => {
    
    class $$ {
        constructor(selector, where = document) {
            this.self = where.querySelector(selector);
            this.elems = where.querySelectorAll(selector);
        }

        each(callback) {
            this.elems.forEach(elem => {
                return callback(elem);
            })
        }
        
        on(event, callback) {
            this.elems.forEach(elem => {
                elem.addEventListener(event, () => {
                    return callback(elem);
                })
            })
        }
    }

    new $$('.popup__close').on('click', () => {
        new $$('body').self.classList.remove('lock');
    })

    const popupElement = setInterval(() => {
        if(new $$('#popup:target').self) {
            new $$('body').self.classList.add('lock');
            clearInterval(popupElement);
        }
    }, 50);

    new $$('.popup__body').each(item => {
        item.addEventListener('click', (e) => {
            if(!e.target.closest('.popup__body-content')) {
                new $$('.popup__close').self.click();
            }
        })
    })
})